import { IPrefixSearchCriteria } from './types';

export const argumentifyPrefixSearchCriteria = ({ filterText, skipCount, maxResultCount }: IPrefixSearchCriteria) =>
  [filterText, skipCount, maxResultCount] as const;
